import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GridModule } from '@progress/kendo-angular-grid';
import { ContractualHierarchyPage } from './contractual-hierarchy';
import { FoundationModule } from '../../../_foundation/foundation.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { PtKendoModule } from '../../../_foundation/kendo/modules/pt.kendo.module';

@NgModule({
  declarations: [
    ContractualHierarchyPage
  ],
  imports: [
    IonicPageModule.forChild(ContractualHierarchyPage),
    PtKendoModule,
    GridModule,
    FoundationModule,
    DirectivesModule,
  ],
  providers: []
})

export class ContractualHierarchyPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/validation/contractual-hierarchy/contractual-hierarchy.module.ts